import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ['loaded', 'error']

  static values = {
    url: String,
    page: Number,
    pending: { type: Boolean, default: true }
  }

  load() {
    if (!this.pendingValue) return

    this.pendingValue = false
    this.#loadImage()
  }

  reload() {
    this.element.classList.remove(this.errorClass)
    this.#loadImage()
  }

  #loadImage() {
    const image = new Image()
    image.src = this.urlValue
    image.alt = ''

    image.addEventListener('load', () => {
      this.#addImage(image)
    })

    image.addEventListener('error', () => {
      this.element.classList.add(this.errorClass)
    })
  }

  #addImage(image) {
    this.element.appendChild(image)
    this.element.classList.add(this.loadedClass)
  }
}
